var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6301 2.39992L17.8294 1.5H16.33H3.67H2.17063L3.3699 2.39992L9.6999 7.14992L10 7.37512L10.3001 7.14992L16.6301 2.39992ZM2.3 2.85L1.5 2.25V3.25V13C1.5 13.3978 1.65804 13.7794 1.93934 14.0607C2.22065 14.342 2.60218 14.5 3 14.5H17C17.3978 14.5 17.7794 14.342 18.0607 14.0607C18.342 13.7794 18.5 13.3978 18.5 13V3.25V2.25L17.7 2.85L10.3 8.4C10.2135 8.46491 10.1082 8.5 10 8.5C9.89181 8.5 9.78655 8.46491 9.7 8.4L2.3 2.85ZM3 0.5H17C17.663 0.5 18.2989 0.763392 18.7678 1.23223C19.2366 1.70107 19.5 2.33696 19.5 3V13C19.5 13.663 19.2366 14.2989 18.7678 14.7678C18.2989 15.2366 17.663 15.5 17 15.5H3C2.33696 15.5 1.70107 15.2366 1.23223 14.7678C0.763392 14.2989 0.5 13.663 0.5 13V3C0.5 2.33696 0.763392 1.70107 1.23223 1.23223C1.70107 0.763392 2.33696 0.5 3 0.5Z",
    fill: "#221F1F",
    stroke: "#221F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.a191be99ccb98bcf462e6f191e4e4674.svg";
export { ForwardRef as ReactComponent };